const FilterIcon = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.83 0a.826.826 0 00-.811 1H.017l.62 2.945a.82.82 0 00.282.463l.115.112c.806.588 3.89 3.034 4.624 4.476v6.175c0 .318.177.604.463.745.113.055.24.084.367.084.184 0 .358-.06.502-.17l2.635-2.014a.836.836 0 00.327-.661V8.83c.068-.14.21-.4.45-.672 1.066-1.214 3.107-3.191 3.88-3.683l.08-.06c.043-.037.08-.078.117-.123a.52.52 0 00.037-.053l.097-.118.96-3.044a.833.833 0 00-.122-.738V.337a.835.835 0 00-.67-.337H.83zM1.85 1.658h11.8l-.406 1.288H2.122l-.27-1.288zm5.466 7.155a.783.783 0 00-.064-.318c-.499-1.198-2.111-2.743-3.46-3.89h7.772a38.281 38.281 0 00-2.407 2.459 4.44 4.44 0 00-.816 1.318.826.826 0 00-.047.277v4.085l-.978.748V8.813z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ShareIcon = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.015 1.853c.14.332.278.646.427.955.538 1.125-.405 1.713-.857 1.996-.077.048-.157.097-.236.15l-.658.439c-.678.45-1.265.84-1.958 1.354-2.14 1.595-3.345 4.042-3.278 6.4C3.4 9.994 5.817 8.025 8.66 7.288l.15-.04c1.192-.351 1.702.396 1.899.873.159.387.323.773.496 1.177l2.906-5.665-6.096-1.779zM1.112 16L1.066 16a.728.728 0 01-.642-.486c-1.202-3.444.213-7.529 3.441-9.932a43.422 43.422 0 012.021-1.4l.653-.435c.093-.061.186-.12.276-.176.088-.056.206-.129.286-.188-.238-.51-.443-1.001-.673-1.55-.107-.259-.22-.53-.344-.819A.726.726 0 016.957.03l8.406 2.453a.726.726 0 01.444 1.03l-4.013 7.824c-.128.251-.376.42-.672.394a.726.726 0 01-.642-.44l-.354-.82a127.284 127.284 0 01-.79-1.856.99.99 0 00-.118.028l-.192.052c-2.925.76-5.368 3.082-7.264 6.902a.726.726 0 01-.65.404z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const FacebookIcon = () => (
  <svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 0C27.165 0 35 7.835 35 17.5S27.165 35 17.5 35 0 27.165 0 17.5 7.835 0 17.5 0zm1.284 7.096c-3.883 0-4.765 2.616-4.765 4.286v2.336h-2.246v3.61h2.246V27.6h4.722V17.328h3.117l.413-3.606h-3.53v-2.125c0-.796.585-.984 1.002-.984h2.537V7.11z"
      fill="#3B5998"
      fillRule="evenodd"
    />
  </svg>
)

const TwitterIcon = () => (
  <svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 0C27.165 0 35 7.835 35 17.5S27.165 35 17.5 35 0 27.165 0 17.5 7.835 0 17.5 0zm4.589 11c-2.307 0-4.175 1.68-4.175 3.752 0 .294.036.581.108.856-3.47-.157-6.546-1.65-8.605-3.922-.36.555-.565 1.2-.565 1.887 0 1.302.737 2.452 1.856 3.124a4.514 4.514 0 01-1.891-.47v.048c0 1.817 1.44 3.334 3.349 3.679a4.6 4.6 0 01-1.886.065c.533 1.491 2.074 2.576 3.902 2.606-1.43 1.007-3.23 1.606-5.186 1.606-.338 0-.67-.017-.996-.052a12.798 12.798 0 006.399 1.686c7.68 0 11.88-5.719 11.88-10.678 0-.163-.005-.324-.012-.485a8.055 8.055 0 002.083-1.942c-.749.298-1.554.5-2.398.59.862-.464 1.523-1.2 1.837-2.075a8.985 8.985 0 01-2.652.91C24.375 11.455 23.29 11 22.089 11z"
      fill="#55ACEE"
      fillRule="evenodd"
    />
  </svg>
)

const icons = {
  filter: <FilterIcon />,
  share: <ShareIcon />,
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />
}

const Icon = ({ name }) => icons[name]

export default Icon
